import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class ScrollRows {
  static init() {
    console.debug('== ScrollRows components ==')

    const scrollRowsContainers = document.querySelectorAll('.animate-scroll-rows')
    if (scrollRowsContainers.length != 0) {
      animateScrollRows(scrollRowsContainers)
    }
  }

  static destroyScrolls() {
    ScrollTrigger.killAll()
  }
}

function animateScrollRows(containers) {
  containers.forEach((container) => {
    const rows = container.querySelectorAll('.scroll-row')
    
    if (rows.length === 0) return

    rows.forEach((row, index) => {
      // Prima riga (index 0) si muove da sinistra a destra
      // Seconda riga (index 1) si muove da destra a sinistra
      const isFirstRow = index % 2 === 0
      
      // Calcola la posizione iniziale e finale per allineare al bordo
      const getStartPosition = () => {
        const rowWidth = row.scrollWidth
        const containerWidth = container.offsetWidth
        // Prima riga: inizia da sinistra (negativo)
        // Seconda riga: inizia da destra (positivo)
        return isFirstRow ? -(rowWidth - containerWidth) / 4 : (rowWidth - containerWidth) / 4
      }
      
      const getEndPosition = () => {
        const rowWidth = row.scrollWidth
        const containerWidth = container.offsetWidth
        // Prima riga: finisce a destra (positivo)
        // Seconda riga: finisce a sinistra (negativo)
        return isFirstRow ? (rowWidth - containerWidth) / 4 : -(rowWidth - containerWidth) / 4
      }

      gsap.fromTo(row, 
        {
          x: () => getStartPosition()
        },
        {
          x: () => getEndPosition(),
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            markers: false,
            invalidateOnRefresh: true, // Ricalcola i valori al resize
          }
        }
      )
    })
  })
}
